import { Box, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useUserData from "../../../../hooks/user/useUserData";
import { FOOTER } from "../../../../locales/components/namespaces";
import BrandLogosMarquee from "./brandLogosMarquee";
import FooterNewsletterSection from "./footerNewsletterSection";
import FooterMenuColumn from "./footerMenuColumn";
import FooterContactSection from "./footerContactSection";
import FooterBottomSection from "./footerBottomSection";
import { useHistory } from "react-router-dom";
import {
    ROUTE_ABOUT_US,
    ROUTE_EXTRA_PAGE,
    ROUTE_PRODUCT_LIST,
    ROUTE_SHIPPING_WAYS,
} from "../../../../routers/routes";

const Footer = () => {
    const theme = useTheme();
    const history = useHistory();
    const { t, i18n } = useTranslation(FOOTER);
    const { language } = useUserData();

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language, i18n]);

    const brewItems = [
        { title: t("brew_filters"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_pour_over"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_scales"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_pitchers"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_kettles"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_thermos"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_cleaners"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_espresso"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_tea"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_barista_tools"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_beverages"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_cold_brew"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_grinders"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_stock"), page: ROUTE_PRODUCT_LIST },
        { title: t("brew_parts"), page: ROUTE_PRODUCT_LIST },
    ];

    const lunoraItems = [
        { title: t("lunora_coffees"), page: ROUTE_PRODUCT_LIST },
        { title: t("lunora_joy"), page: ROUTE_PRODUCT_LIST },
        { title: t("lunora_beverages"), page: ROUTE_PRODUCT_LIST },
        { title: t("lunora_syrups"), page: ROUTE_PRODUCT_LIST },
        { title: t("lunora_consumables"), page: ROUTE_PRODUCT_LIST },
    ];

    const companyItems = [
        { title: t("company_about"), page: ROUTE_ABOUT_US },
        { title: t("company_payment"), page: ROUTE_EXTRA_PAGE },
        { title: t("company_shipping"), page: ROUTE_SHIPPING_WAYS },
    ];

    const footerLinks = [t("terms"), t("cookies"), t("gdpr")];

    const onSubmit = (data) => {
       // console.log("Newsletter Email Submitted: ", data);
    };

    return (
        <Box
            sx={{
                width: "100%",
                //maxWidth: "1440px",
                mx: "auto",
                px: { xs: 1.5, sm: 2, md: 3 },
                mt: { xs: 2, md: 2 },
                mb: 1,
            }}
        >
            <Box
                sx={{
                    bgcolor: "#E9E9E9",
                    borderRadius: { xs: "20px", sm: "24px", md: "30px" },
                    px: { xs: 2, sm: 3, md: 5, lg: 6 },
                    py: { xs: 3, sm: 4, md: 5 },
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "1fr",
                            lg: "minmax(280px, 380px) 1fr",
                        },
                        gap: { xs: 4, md: 5, lg: 8 },
                        alignItems: "start",
                    }}
                >
                    {/* Newsletter */}
                    {/*<Box sx={{ minWidth: 0, width: "100%" }}>*/}
                    {/*    <FooterNewsletterSection onSubmit={onSubmit} />*/}
                    {/*</Box>*/}

                    {/* Right content */}
                    <Box
                        sx={{
                            minWidth: 0,
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                sm: "repeat(2, minmax(0, 1fr))",
                                md: "repeat(3, minmax(0, 1fr))",
                                lg: "repeat(3, minmax(0, 1fr))",
                            },
                            gap: { xs: 3, sm: 4, md: 4, lg: 6 },
                            alignItems: "start",
                        }}
                    >
                        {/* Contact first on mobile */}
                        <Box sx={{ display: { xs: "block", lg: "none" }, minWidth: 0 }}>
                            <FooterContactSection />
                        </Box>

                        <Box sx={{ minWidth: 0 }}>
                            <FooterMenuColumn
                                history={history}
                                title={t("brew")}
                                items={brewItems}
                            />
                        </Box>

                        <Box sx={{ minWidth: 0 }}>
                            <FooterMenuColumn
                                history={history}
                                title={t("lunora")}
                                items={lunoraItems}
                            />

                            <Box sx={{ mt: { xs: 3, md: 4 } }}>
                                <FooterMenuColumn
                                    history={history}
                                    title={t("company")}
                                    items={companyItems}
                                />
                            </Box>
                        </Box>

                        <Box sx={{ display: { xs: "none", lg: "block" }, minWidth: 0 }}>
                            <FooterContactSection />
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ mt: { xs: 4, md: 5 } }}>
                    <FooterBottomSection footerLinks={footerLinks} />
                </Box>
            </Box>

            <Box
                sx={{
                    width: "100%",
                    mt: 1.5,
                    px: { xs: 0.5, sm: 1 },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                    }}
                >
                    <BrandLogosMarquee gap={3} duration={60} />
                </Box>
            </Box>
        </Box>
    );
};

export default Footer;